export default {
    dependencies: ['$element', 'reqwest', 'radio'],
    callable(form, reqwest, radio) {
        let prevFilters = null;

        form.addEventListener('submit', e => {
            handleFormChange();
            e.preventDefault();
        });
        form.addEventListener('change', handleFormChange);

        function handleFormChange() {
            let filters = reqwest.serializeArray(form);
            if (
                prevFilters &&
                JSON.stringify(filters) === JSON.stringify(prevFilters)
            ) {
                radio('searchFilter.notChanged').broadcast();
                // Nothing changed, no need to update
                return;
            }
            prevFilters = filters;
            filters = filters.filter(e => e.value !== '');

            radio('searchFilter.changed').broadcast(filters);
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/searchFilter.js